import { useEffect } from 'react';

import { useGlobalStore } from 'store';
import { ColoredHeaderType } from 'types/shared';

const useColoredHader = (title: ColoredHeaderType) => {
  const { headerText: headerTextStore, setHeaderText } = useGlobalStore();

  useEffect(() => {
    if (title) {
      if (title.headerColoredText)
        setHeaderText({
          ...headerTextStore,
          normal: title.headerText,
          colored: title.headerColoredText,
          color: title.color,
        });
      else
        setHeaderText({
          ...headerTextStore,
          default: title.headerText,
        });
    }
    // @ts-ignore
  }, [title]);
};

export default useColoredHader;
